import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/styles';
import {
  Avatar,
  useMediaQuery,
  Grid2 as Grid,
  Box,
  Card,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import { SectionHeader } from 'components/molecules';

const WhyMperito = props => {
  const { data, className, ...rest } = props;  

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="Why Choose Mperito for Your ONDC Journey?"
        subtitle=""
      />
      <Grid container spacing={isMd ? 2 : 1}>
        {data?.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 6 }}>
            <Box
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <Box
                component={Card}
                padding={4}
                borderRadius={2}
                width={1}
                height={1}
                data-aos={'fade-up'}
                data-aos-delay={item * 100}
                data-aos-offset={100}
                data-aos-duration={600}
              >
                <Box display={'flex'} flexDirection={'column'}>
                  <Box
                    component={Avatar}
                    width={60}
                    height={60}
                    marginBottom={2}
                    bgcolor={alpha(item.color, 0.1)}
                    color={item.color}
                    variant={'rounded'}
                    borderRadius={2}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    sx={{ fontWeight: 700 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.subtitle}
                  </Typography>
                  <Box sx={{ flexGrow: 1 }} />
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

WhyMperito.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default WhyMperito;
